import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance';
import { CLOUDINARY_UPLOAD_PRESET, baseURL,timestamp } from '../common'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const RequestStudentForm = ({ closeModal }) => {

    const CLOUDINARY_URL = baseURL;
    const CLOUDINARY_UPLOAD = CLOUDINARY_UPLOAD_PRESET;
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [showEmploymentFields, setShowEmploymentFields] = useState(false); // State to manage visibility of employment fields
    const [uploadedFileUrl, setUploadedFileUrl] = useState('');
    const [courses, setCourses] = useState([]);

    const [studentData, setStudentData] = useState({
        fullname: '',
        nric: '',
        email: '',
        phone: null,
        gender: '',
        dob: '',
        password: '',
        address: '',
        course: '',
        citizenship: '',
        postalcode: '',
        race: '',
        education: '',
        employmentstatus: '',
        salary: '',
        companyname: '',
        corporatecompanysponsored: '',
        designation: '',
        profileUrl: '',
        batch: '',
        Batch_id: null,
        status: false,
        passport: '',
        passportExpiryDate: '',
        fatherName: '',
        brotherName: '',
        fatherPhoneNo: '',
        brotherPhoneNo: '',
        religion: '',
        currentAddress: '',
        institutionDetails: [],
        workExpirences: []
    });


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedFile(file); // Store the file in state
        }
    };

    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 3; // Total number of steps in the wizard
    const nextStep = (e) => {
        e.preventDefault(); // Prevent the default form submission behavior
        setCurrentStep((prevStep) => prevStep + 1);
    };

    const prevStep = (e) => {
        e.preventDefault();
        setCurrentStep((prevStep) => prevStep - 1);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStudentData({
            ...studentData,
            [name]: value
        });
    };

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get('courses'); // Replace with your API URL
                setCourses(response.data); // Assuming the response data is an array of course objects
            } catch (error) {
                console.error('Error fetching courses:', error);
            }
        };

        fetchCourses();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // If it's the final step in the multi-step form
        if (currentStep === totalSteps) {
            // If not currently uploading
            if (!isUploading) {
                try {
                    let profileUrl = '';

               

                    // Upload the file if a file is selected
                    if (selectedFile) {
                        const formData = new FormData();
                        // Append file and upload details to FormData
                        formData.append('file', selectedFile);
                        formData.append('upload_preset', CLOUDINARY_UPLOAD);
                        formData.append('public_id', `LMS/RequestStudent/${selectedFile.name}+' - '+${timestamp}`); 
                        const response = await fetch(baseURL, {
                            method: 'POST',
                            body: formData,
                        });

                        const data = await response.json();
                        if (data.secure_url) {
                            profileUrl = data.secure_url; // Store the URL
                            setUploadedFileUrl(profileUrl);
                        } else {
                            throw new Error('Failed to upload image.');
                        }
                    }

                    const updatedStudentData = { ...studentData, profileUrl };


                    // Send the form data (with or without image) to the server
                    const response = await axios.post('requeststudent', updatedStudentData);

                    // Clear the form and close the modal
                    // clearForm();
                    closeModal();
                } catch (submitError) {
                    console.error('Submission Error:', submitError);
                }
            }
        } else {
            // Proceed to the next step in the multi-step form
            nextStep();
        }
    };

    // const clearForm = () => {
    //     setStudentData({
    //         fullname: '',
    //         nric: '',
    //         email: '',
    //         phone: '',
    //         gender: '',
    //         dob: '',
    //         password: '',
    //         address: '',
    //         postalcode: '',
    //         race: '',
    //         education: '',
    //         employmentstatus: '',
    //         salary: '',
    //         companyname: '',
    //         corporatecompanysponsored: '',
    //         designation: '',
    //         status: '',
    //         profileUrl: '',
    //         batch: '',
    //         batch_id: ''
    //     });
    //     setSelectedFile(null); // Clear the selected file
    // };

    const handleInstitutionChange = (index, e) => {
        const { name, value } = e.target;
        const newInstitutionDetails = studentData.institutionDetails.map((institution, i) => {
            if (i === index) {
                return { ...institution, [name]: value };
            }
            return institution;
        });
        setStudentData({
            ...studentData,
            institutionDetails: newInstitutionDetails
        });
    };

    const handleAddEducation = () => {
        setStudentData({
            ...studentData,
            institutionDetails: [
                ...studentData.institutionDetails,
                { institution: '', qualificationsAchieved: '', year: '' }
            ]
        });
    };


    const handleRemoveEducation = (index) => {
        const newInstitutionDetails = studentData.institutionDetails.filter((_, i) => i !== index);
        setStudentData({ ...studentData, institutionDetails: newInstitutionDetails });
    };

    const handleWorkExperienceChange = (index, e) => {
        const { name, value } = e.target;
        const newWorkExperiences = studentData.workExpirences.map((experience, i) => {
            if (i === index) {
                return { ...experience, [name]: value };
            }
            return experience;
        });
        setStudentData({
            ...studentData,
            workExpirences: newWorkExperiences
        });
    };

    const handleAddWorkExperience = () => {
        setShowEmploymentFields(true);
        setStudentData({
            ...studentData,
            workExpirences: [
                ...studentData.workExpirences,
                { name: "", position: "", year: "" } // Add a new empty work experience object
            ]
        });
    };

    const handleRemoveWorkExperience = (index) => {

        const newWorkExperiences = studentData.workExpirences.filter((_, i) => i !== index);
        setStudentData({
            ...studentData,
            workExpirences: newWorkExperiences
        });
    };
    const formContainerStyle = {
        maxHeight: '800px',
        overflowY: 'auto',
        padding: '15px',
        maxWidth: '1000px', // Ensure it's maxWidth, not maxwidth
        width: '100%', // Ensures the content takes full width up to maxWidth
        margin: '0 auto' // Centers the container horizontally
    };

    const renderFormStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <div >
                        {/* Section 1 Fields */}
                        <div className="row mb-3">
                            <label htmlFor="fullname" className="form-label">Name*</label>
                            <input
                                type="text"
                                // style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="fullname"
                                className="form-control"
                                name="fullname"
                                value={studentData.fullname}
                                onChange={handleChange}
                                required
                            />

                            <label htmlFor="Passport Number" className="form-label">Passport Number</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="fullname"
                                className="form-control"
                                name="passport"
                                value={studentData.passport}
                                onChange={handleChange}
                            />

                            <label htmlFor="Passport Expiry Date" className="form-label">Passport Expiry Date</label>
                            <input
                                type="date"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="fullname"
                                className="form-control"
                                name="passportExpiryDate"
                                value={studentData.passportExpiryDate}
                                onChange={handleChange}
                                required
                            />

                            <label htmlFor="nric" className="form-label">NRIC/FIN</label>
                            <input
                                type="text"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="nric"
                                className="form-control"
                                name="nric"
                                value={studentData.nric}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor="email" className="form-label">Email</label>
                            <input
                                type="email"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                id="email"
                                className="form-control"
                                name="email"
                                value={studentData.email}
                                onChange={handleChange}
                                required
                            />

                            {/* <div className="form-group"> */}
                            <label htmlFor="course">Course*</label>
                            <select
                                id="course"
                                className="form-control"
                                name="course"
                                value={studentData.course}
                                onChange={handleChange}
                                style={{ width: '100%', height: '45px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                required
                            >
                                <option value="">Select a course</option>
                                {courses.map((course) => (
                                    <option key={course.id} value={`${course.name}(${course.id})`}>
                                        {course.name}
                                    </option>
                                ))}
                            </select>
                            {/* </div> */}

                            {/* <div className="form-group"> */}
                            <label htmlFor="citizen">Citizenship*</label>
                            <input
                                type="text"
                                id="citizenship"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                className="form-control"
                                name="citizenship"
                                value={studentData.citizenship}
                                onChange={handleChange}
                                required
                            />
                            {/* </div> */}


                            <label htmlFor="Hand Phone" className="form-label">Hand Phone</label>
                            <input
                                type="tel"  // Use "tel" type for phone numbers
                                id="phone"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                className="form-control"
                                name="phone"
                                value={studentData.phone}
                                onChange={handleChange}
                                required
                            />

                            <label htmlFor="Office Phone" className="form-label">Office Phone</label>
                            <input
                                type="tel"  // Use "tel" type for phone numbers
                                id="phone"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                className="form-control"
                                name="officephone"
                                value={studentData.officephone}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor="gender" className="form-label">Gender</label>
                            <select
                                id="gender"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                className="form-control"
                                name="gender"
                                value={studentData.gender}
                                onChange={handleChange}
                            >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                        <button type="button" className="btn btn-primary" onClick={nextStep}>
                            Next
                        </button>
                    </div>
                );
            case 2:
                return (
                    <div>
                        <div className="row mb-3">
                            <label htmlFor="dob" className="form-label">Date of Birth</label>
                            <input
                                type="date"
                                id="dob"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                className={`form-control`}
                                name="dob"
                                value={studentData.dob}
                                onChange={handleChange}
                                // max={formatDate(new Date())} // Set the max attribute to today's date
                                required
                            />

                            <label htmlFor="password" className="form-label">Password</label>
                            <input
                                type="password"
                                id="password"
                                className="form-control"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                name="password"
                                value={studentData.password}
                                onChange={handleChange}
                                required
                            />
                            <label htmlFor=" Singapore address" className="form-label">Singapore Address</label>
                            <input
                                type="text"
                                id="address"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                className="form-control"
                                name="currentAddress"
                                value={studentData.currentAddress}
                                onChange={handleChange}
                                required
                            />

                            <label htmlFor="Home Address" className="form-label">Home Address</label>
                            <input
                                type="text"
                                id="address"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                className="form-control"
                                name="address"
                                value={studentData.address}
                                onChange={handleChange}
                                required
                            />
                            {/* <label htmlFor="postalcode" className="form-label">Postal Code</label>
                            <input
                                type="number"
                                required
                                name="postalcode"
                                value={studentData.postalcode}
                                onChange={(e) => {
                                    const inputValue = e.target.value.replace(/\D/g, ''); // Allow only digits
                                    const truncatedValue = inputValue.substring(0, 6); // Limit to a maximum of 6 digits

                                    // Update the state with the truncated value
                                    handleInputChange({ target: { name: "postalcode", value: truncatedValue } });
                                }}
                                placeholder="Postal Code"
                                className="form-control"
                            /> */}
                            <label htmlFor="race" className="form-label">Religion</label>
                            <input
                                type="text"
                                id="race"
                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                className="form-control"
                                name="religion"
                                value={studentData.religion}
                                onChange={handleChange}
                                required
                            />

                            <div style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="address">Father Name *</label>
                                    <input
                                        type="text"
                                        id="address"
                                        style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                        className="form-control"
                                        name="fatherName"
                                        value={studentData.fatherName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div>
                                    <label htmlFor="address">Father Phone No*</label>
                                    <input
                                        type="text"
                                        id="address"
                                        style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                        className="form-control"
                                        name="fatherPhoneNo"
                                        value={studentData.fatherPhoneNo}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group" style={{ display: 'flex', gap: '20px' }}>
                                <div style={{ flex: 1 }}>
                                    <label htmlFor="address">Brother Name *</label>
                                    <input
                                        type="text"
                                        id="address"
                                        style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                        className="form-control"
                                        name="brotherName"
                                        value={studentData.brotherName}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>


                                <div className="form-group">
                                    <label htmlFor="address">Brother Phone No*</label>
                                    <input
                                        type="text"
                                        id="address"
                                        style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}

                                        className="form-control"
                                        name="brotherPhoneNo"
                                        value={studentData.brotherPhoneNo}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>

                        </div>
                        <button className="btn btn-secondary" onClick={(e) => prevStep(e)}>
                            Previous
                        </button>
                        <button type="button" className="btn btn-primary" onClick={(e) => nextStep(e)}>
                            Next
                        </button>
                    </div>
                );
            case 3:
                return (
                    <div>
                        <div className="row mb-3">


                            <button
                                type="button"
                                onClick={handleAddWorkExperience}
                                style={{
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    fontSize: '16px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    borderRadius: '8px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                + Add Employment

                            </button>

                            {/* Employment Status Fields */}
                            {showEmploymentFields && (
                                studentData.workExpirences.map((experience, index) => (
                                    <div key={index}>
                                        <div className="form-group">
                                            <label htmlFor={`companyname-${index}`}>Company Name*</label>
                                            <input
                                                type="text"
                                                id={`companyname-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="name"
                                                value={experience.name}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`position-${index}`}>Position*</label>
                                            <input
                                                type="text"
                                                id={`position-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="position"
                                                value={experience.position}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`year-${index}`}>Year*</label>
                                            <input
                                                type="text"
                                                id={`year-${index}`}
                                                style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                                className="form-control"
                                                name="year"
                                                value={experience.year}
                                                onChange={(e) => handleWorkExperienceChange(index, e)}
                                                required
                                            />
                                        </div>

                                        {/* Button to remove the work experience entry */}
                                        <button
                                            type="button"
                                            onClick={() => handleRemoveWorkExperience(index)}
                                            style={{
                                                margin: '10px 0',
                                                padding: '5px 15px',
                                                fontSize: '16px',
                                                backgroundColor: 'red',
                                                color: 'white',
                                                borderRadius: '8px',
                                                border: 'none',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.3s ease',
                                                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                )))}



                            <button
                                type="button"
                                onClick={handleAddEducation}
                                style={{
                                    margin: '10px 0',
                                    padding: '10px 20px',
                                    fontSize: '16px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    borderRadius: '8px',
                                    border: 'none',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s ease',
                                    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                }}
                            >
                                + Add Education
                            </button>
                            {studentData.institutionDetails.map((institution, index) => (
                                <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #ced4da', borderRadius: '6px' }}>
                                    <div className="form-group">
                                        <label htmlFor={`institution-${index}`}>Institution Name*</label>
                                        <input
                                            type="text"
                                            id={`institution-${index}`}
                                            style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                            className="form-control"
                                            name="institution"
                                            value={institution.institution}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor={`degree-${index}`}>Degree*</label>
                                        <input
                                            type="text"
                                            id={`qualificationsAchieved-${index}`}
                                            style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                            className="form-control"
                                            name="qualificationsAchieved"
                                            value={institution.qualificationsAchieved}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor={`year-${index}`}>Year of Graduation*</label>
                                        <input
                                            type="text"
                                            id={`year-${index}`}
                                            style={{ width: '100%', height: '42px', borderRadius: '6px', border: '1px solid #ced4da' }}
                                            className="form-control"
                                            name="year"
                                            value={institution.year}
                                            onChange={(e) => handleInstitutionChange(index, e)}
                                            required
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        onClick={() => handleRemoveEducation(index)}
                                        style={{
                                            margin: '10px 0',
                                            padding: '5px 15px',
                                            fontSize: '16px',
                                            backgroundColor: 'red',
                                            color: 'white',
                                            borderRadius: '8px',
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'background-color 0.3s ease',
                                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            ))}


                            <label htmlFor="profileUrl" className="form-label">Profile URL</label>
                            <input type="file" name="file"
                                onChange={(event) => {
                                    const file = event.target.files[0];
                                    if (file && file.size > 8 * 1024 * 1024) {
                                        event.target.value = ""; // Reset file input
                                        alert("File size must be less than 8MB.");
                                    } else {
                                        handleFileChange(event);
                                    }
                                }}
                                className="form-control" />
                            {selectedFile && <div>Selected File: {selectedFile.name}</div>}


                        </div>
                        <button className="btn btn-secondary" onClick={prevStep}>
                            Previous
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Submit
                        </button>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="containerw " style={formContainerStyle}>


            <div style={{ padding: '15px' }}>
                <form onSubmit={handleSubmit}>
                    {renderFormStep()}
                </form>
                <ToastContainer />
            </div>
        </div>
    );

};

export default RequestStudentForm;



